import { IdentifierDTO } from '@zazume/zzm-base';

import { Invitation } from '#/domain/invitation/Invitation';
import { AssignReferralRequest, OwnerReferrals } from '#/domain/referral/OwnerReferrals';
import { doDelete, doGet, doPost, parserDataList } from '#lib/network/helpers';

export const invitations = {
  sendByEmail: (email: string) => doPost<void>('/invitation/send-by-email', { email }),
  getAll: () => doGet<Invitation[]>('/invitation/all', parserDataList(Invitation.fromRaw)),
  getAllReceived: () => doGet<Invitation[]>('/invitation/received', parserDataList(Invitation.fromRaw)),
  getOwnerReferrals: (ownerAccountId: IdentifierDTO) => () =>
    doGet<OwnerReferrals>(`/invitation/owner-account/${ownerAccountId}/referrals`),
  canOwnerRefer: (ownerAccountId: IdentifierDTO) => () =>
    doGet<{ canRefer: boolean }>(`/invitation/owner-account/${ownerAccountId}/can-refer`),
  assignReferral: (request: AssignReferralRequest) => doPost<void>('/invitation/assign-owner-referral', request),
  removeReferral: (invitationId: IdentifierDTO) => doDelete<void>(`/invitation/${invitationId}`)
};
